import { Box, Typography } from '@mui/material'
import SupersetDashboard from './EmbeddedSuperset'
import { useTranslation } from 'react-i18next'

interface IDashboard {
    analyticsDashboardId: string
}

const Dashboard = (props: IDashboard): JSX.Element => {
    const { t } = useTranslation()
    const dashboardId = props.analyticsDashboardId
    return !dashboardId ? (
        <Typography
            id="no-dashboard-available"
            variant="h6"
            component="h2"
            sx={{ color: '#000000', textAlign: 'center' }}
        >
            {t('noDashboardAvailable')}
        </Typography>
    ) : (
        <Box sx={{ width: '100%', height: '100%' }}>
            <SupersetDashboard dashboardId={dashboardId} />
        </Box>
    )
}

export default Dashboard
